import { CFMixins } from '../../../../mixins';
import { TEXT_COLOR } from '../tokens';
import { getTypeSpec } from '../utils';
export const valueColor = ({ disabled, isPlaceholder, }) => {
    if (disabled)
        return TEXT_COLOR.DISABLED;
    if (isPlaceholder)
        return TEXT_COLOR.PLACEHOLDER;
    return TEXT_COLOR.DEFAULT;
};
export const valueTypeSpec = ({ fieldSize }) => CFMixins.typeSpec(getTypeSpec(fieldSize));
